import CommonBridge from './bridge_common.js';
import router from '@/router/index.js';
import { instance } from '@/apis/index';
import store from '@/store/index.js';
import { ORIGIN } from '@/jmHttp/host.js';
import { inVite } from '@/utils/api';

function Bridge() {
  this.title = '进门';

  this.isThirdParty = false;

  this.favicon = `${ORIGIN}/favicon.ico`;

  this.logo = '';

  // 是否显示菜单
  this.showMenu = location.pathname.includes('/thirdparty/') ? false : true;
}

// 机构合作页面才要
if (location.pathname.includes('/thirdparty/')) {
  // 重新登陆窗口点击事件 默认不做跳转
  Bridge.prototype.reLogin = function () {};
  // 重新登陆窗按钮文案
  Bridge.prototype.reLoginInfo = {
    confirmText: '确定',
    message: '用户未授权'
  };
}

const mergeObject = function (to, from) {
  Object.keys(from).forEach((key) => {
    if (Object.prototype.toString.call(from[key]) === '[object Object]') {
      to[key] = to[key] || {};
      mergeObject(to[key], from[key]);
    } else {
      to[key] = from[key];
    }
  });
};

const initBridge = function (bridge) {
  if (inVite()) {
    const files = import.meta.glob('./bridge_*.js', { eager: true });
    for (const key in files) {
      const module = files[key];
      if (module.isThirdParty) {
        bridge.isThirdParty = true;
        return module.default; // 返回第三方 Bridge 类
      }
    }
  } else {
    const files = require.context('./', false, /^(\.\/bridge_).*?(\.js)$/);
    const arr = files.keys();
    for (let index = 0; index < arr.length; index++) {
      const key = arr[index];
      const bridgeModule = files(key);
      const isThirdParty = bridgeModule.isThirdParty;
      if (isThirdParty) {
        bridge.isThirdParty = isThirdParty;
        return bridgeModule.default;
      }
    }
  }
  return null;
};

// 处理原型链，将 ThirdBridge 的整个原型链合并到 Bridge
const mergePrototype = (Bridge, ThirdBridge) => {
  // 递归合并实例原型链上的所有方法
  let currentProto = Object.getPrototypeOf(ThirdBridge);
  while (currentProto && currentProto !== Object.prototype) {
    // 获取当前原型上的所有属性和方法
    const descriptors = Object.getOwnPropertyDescriptors(currentProto);

    // 合并到Bridge.prototype，跳过constructor
    Object.keys(descriptors).forEach((key) => {
      if (key !== 'constructor' && !Bridge.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Bridge.prototype, key, descriptors[key]);
      }
    });

    // 移动到下一个原型
    currentProto = Object.getPrototypeOf(currentProto);
  }
};

// 清除登录信息的操作、第三方和进门的登录信息需要互顶，第三方和第三方之间也需要互顶。
const initUserInfo = () => {};

let $bridge = null;

const install = (app) => {
  const bridge = new Bridge();
  const ThirdBridge = initBridge(bridge);

  if (bridge.isThirdParty) {
    //处理原型链
    Object.assign(Bridge.prototype, CommonBridge.prototype);
    //处理变量
    mergeObject(bridge, new CommonBridge());

    //处理原型链
    mergePrototype(Bridge, ThirdBridge);
    //处理变量
    mergeObject(bridge, ThirdBridge);
  }

  initUserInfo(bridge);

  app.config.globalProperties.$bridge = bridge;
  $bridge = bridge;
  app.provide('bridge', bridge);
  app.provide('isThirdParty', bridge.isThirdParty);
  store.commit('setBridgeInfo', bridge);
  // 挂在router实例
  router.app = app;
  instance.app = app;
};

const getCurrentBridge = () => {
  return $bridge;
};

export default { install, getCurrentBridge };
